import { observer } from 'mobx-react-lite'
import { Box, Typography } from 'shared/ui'
import {
  type IColumn,
  type IRowDefault,
  Table,
  TableSearch,
  type TableStore,
} from 'shared/ui/TableNew'

export type IClientsTableProps<T extends IRowDefault> = {
  tableStore: TableStore<T>
  rows: T[]
  columns: IColumn<T>[]
  scrollToTopTrigger: string
}

export const ClientsTable = observer(
  <T extends IRowDefault>({
    tableStore,
    rows,
    columns,
    scrollToTopTrigger,
  }: IClientsTableProps<T>) => {
    const { search, loading, setSearch } = tableStore
    return (
      <Box display='flex' flexDirection='column' height='100%'>
        {!search && !loading && !rows.length ? (
          <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
            justifyContent='center'
            height='100%'
            gap={2}
          >
            <Box
              display='flex'
              flexDirection='column'
              alignItems='center'
              justifyContent='center'
              gap={0.5}
            >
              <Typography variant='body-rg-medium' ariaLabel='NoClientsTitle'>
                No clients yet
              </Typography>
              <Typography variant='body-md-regular' ariaLabel='NoClientsText' color='tertiary'>
                Add one to get started
              </Typography>
            </Box>
          </Box>
        ) : (
          <>
            <TableSearch value={search} onChange={setSearch} />
            <Box flexGrow={1}>
              <Table
                ariaLabel={'ClientsTable'}
                store={tableStore}
                virtualization
                columns={columns}
                rows={rows}
                scrollToTOpTrigger={scrollToTopTrigger}
              />
            </Box>
          </>
        )}
      </Box>
    )
  }
)
